/**
 * 全局配置文件
 */
export default {
  title: '云滴出行业务管理',
  logo: 'YD',
  // key: 'js-Ayundi',
  key: 'yd-admin',
  indexTitle: '云滴出行业务',
  lockPage: '/lock',
  tokenTime: 60 * 60 * 24 * 7,
  tokenKey: 'x-access-token',
  // amapKey: 'b3d68475e2468f2128cf30d901306e56',
  amapKey: 'ad781359afa4db34b178ae78b17718fc',
  securityJsCode: 'fa19a3a5f0ecbc163658011e97be205d',
  /* amapKey: '6373b025552f5d4175df0f3271cc02b8',
  securityJsCode: 'e1e6da537eebc9595cb1a496008b6bba', */
  statusWhiteList: [],
  Authorization: 'Authorization',
  isFirstPage: false,
  auth: {
    client_id: 'api-boss',
    client_secret: '123456',
    grant_type: 'password'
  },
  fistPage: {
    label: '首页',
    value: '/home/index',
    params: {},
    query: {},
    meta: {
      i18n: 'dashboard'
    },
    group: [],
    close: false
  },
  // 配置菜单的属性
  menu: {
    iconDefault: 'iconfont icon-caidan',
    props: {
      label: 'name',
      path: 'path',
      icon: 'icon',
      children: 'children'
    }
  }
}
